<script>
    export let title;
    export let background_color;

    function menu() {
        const menu = document.querySelector(".menu");
        menu.style.zIndex = "1000000";
        menu.classList.add("show-use");
    }
</script>

<!-- svelte-ignore a11y-missing-attribute -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="main-hd" style="background: {background_color}">
    <div class="main-hd-in">
        <img
            src="../resource/img/ico_hd_menu.png"
            class="hd-menu"
            on:click={menu}
        />
        <p class="hd-nm">{title}</p>
    </div>
</div>
